import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScheduleBookingPageComponent } from './pages/schedule-booking-page/schedule-booking-page.component';

@NgModule({
  declarations: [ScheduleBookingPageComponent],
  imports: [CommonModule, FormsModule],
  exports: [ScheduleBookingPageComponent]
})
export class ScheduleModule {}
